export const modelName = 'settings';
export const FETCH_SUCCESS = '@settings/FETCH_SUCCESS';
export const FETCH_FAILED = '@settings/FETCH_FAILED';
